"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _decorators = require("decorators");

require("compat");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class2, _temp;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Carousel = (_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Carousel, _Component);

  function Carousel() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, Carousel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Carousel)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.state = {
      cycle: false,
      leftIndex: 0,
      itemsVisible: 1,
      disabled: false,
      mode: _this.mode,
      isMobile: false
    };
    _this.wheelSamples = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    _this.sampleCount = 0;
    _this.ranWheel = false;
    babelHelpers.initializerDefineProperty(_this, "infinite", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "mode", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "sizeInfinite", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "carouselItemLeaving", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "carouselItemLeft", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "carouselItemEntering", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "carouselItemEntered", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(Carousel, [{
    key: "wheelTimeoutHandler",
    value: function wheelTimeoutHandler() {
      if (this.state.disabled) return;

      if (!this.ranWheel) {
        this.runWheel();
      }

      this.ranWheel = false;
      this.wheelTimeout = null;
      this.sampleCount = 0;
      this.wheelSamples = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    }
  }, {
    key: "wheel",
    value: function wheel(event) {
      var _this2 = this;

      if (this.state.disabled) return;
      if (this.state.itemsVisible >= this.children.length) return;

      if (this.ranWheel) {
        event.preventDefault();
        return;
      }

      console.log(event.deltaMode, event.deltaX, event.deltaY, event.deltaZ);
      this.sampleCount++;
      clearTimeout(this.wheelTimeout);
      this.wheelTimeout = setTimeout(this.wheelTimeoutHandler, 64);
      var offset = 1;
      if (event.deltaMode == 1) offset = 16;
      if (event.deltaMode == 2) offset = window.innerWidth;
      var delta = event.deltaX * offset;
      this.wheelSamples.shift();
      this.wheelSamples.push(delta);
      var dx = 0;

      if (this.wheelSamples.filter(function (v) {
        return Math.abs(_this2.wheelSamples[4]) - Math.abs(v) > 0;
      }).length == 8) {
        dx = this.wheelSamples[4];
      }

      if (dx) {
        this.runWheel();
        this.ranWheel = true;
        event.preventDefault();
      }
    }
  }, {
    key: "runWheel",
    value: function runWheel() {
      if (this.state.disabled) return;
      var direction = this.wheelSamples[4] > 0 ? 1 : this.wheelSamples[4] < 0 ? -1 : 0;
      if (direction == 0) return;
      if (direction < 1) this.cyclePrev(true);else this.cycleNext(true);
    }
  }, {
    key: "logTouchEvent",
    value: function logTouchEvent(event) {
      console.log("".concat(event.type, ": ").concat(this.mapTouches(event.touches), " | ").concat(this.mapTouches(event.changedTouches)));
    }
  }, {
    key: "mapTouches",
    value: function mapTouches(touchList) {
      return [].map.call(touchList, function (touch) {
        return "".concat(touch.identifier, " @ ").concat(touch.clientX, "x").concat(touch.clientY);
      }).join(', ');
    }
  }, {
    key: "touchStart",
    value: function touchStart(event) {
      if (this.state.disabled) return;
      this.logTouchEvent(event);

      if (this.inTouch) {
        this.rejectTouch = true;
        event.preventDefault();
        return;
      }

      this.inTouch = true;
      this.rejectTouch = false;
      this.touch = {
        ID: event.touches[0].identifier,
        X: event.touches[0].clientX,
        Y: event.touches[0].clientY
      };
      this.lastTouch = this.touch;
      this.stopped = false; // event.preventDefault();

      return;
    }
  }, {
    key: "touchMove",
    value: function touchMove(event) {
      if (this.state.disabled) return;
      if (this.stopped) event.preventDefault();
      this.logTouchEvent(event);

      if (this.inTouch && !this.rejectTouch) {
        this.lastTouch = {
          ID: event.touches[0].identifier,
          X: event.touches[0].clientX,
          Y: event.touches[0].clientY
        };

        if (Math.abs(event.touches[0].clientX - this.touch.X) > 30) {
          console.log("touchMove(): trying to stop movement");
          this.stopped = true;
          event.preventDefault();
        }
      }
    }
  }, {
    key: "touchEnd",
    value: function touchEnd(event) {
      if (this.state.disabled) return;
      if (this.stopped) event.preventDefault();
      this.logTouchEvent(event);

      if (this.inTouch && !this.rejectTouch && this.touch && this.lastTouch) {
        var delta, size;
        delta = this.lastTouch.X - this.touch.X;
        size = 340;

        if (Math.abs(delta) > 0.1 * size) {
          delta *= -1;
          if (delta < 0) this.cyclePrev(true);else this.cycleNext(true);
        }
      }

      this.inTouch = false;
      this.rejectTouch = false;
      this.touch = null;
      this.lastTouch = null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.media) {
        this.mediaQuery = window.matchMedia(this.props.media);
        this.mediaQuery.addListener(this.mediaQueryListener);
        this.mediaQueryListener();
      }

      this.mobileMediaQuery = window.matchMedia("(max-width: 767px)");
      this.mobileMediaQuery.addListener(this.mobileMediaQueryListener);
      this.mobileMediaQueryListener();
    }
  }, {
    key: "mobileMediaQueryListener",
    value: function mobileMediaQueryListener() {
      // Enable when the media query specified by props.media matches
      var v = this.mobileMediaQuery.matches;

      if (v != this.state.isMobile) {
        this.setState({
          isMobile: v
        });
      }
    }
  }, {
    key: "mediaQueryListener",
    value: function mediaQueryListener() {
      // Enable when the media query specified by props.media matches
      var v = !this.mediaQuery.matches;

      if (v != this.state.disabled) {
        this.setState({
          disabled: v
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setContentNode(null);

      if (this.mediaQuery) {
        this.mediaQuery.removeListener(this.mediaQueryListener);
        delete this.mediaQuery;
      }
    }
  }, {
    key: "setContentNode",
    value: function setContentNode(node) {
      var _this3 = this;

      if (this.contentNode) {
        this.contentNode.removeEventListener('wheel', this.wheel, {
          passive: false
        });
        this.contentNode.removeEventListener('touchstart', this.touchStart, {
          passive: false
        });
        this.contentNode.removeEventListener('touchmove', this.touchMove, {
          passive: false
        });
        this.contentNode.removeEventListener('touchend', this.touchEnd, {
          passive: false
        });
      }

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.contentNode = node;

      if (node) {
        window.addEventListener('resize', this.resized);

        if (!this.props.noControls) {
          node.addEventListener('wheel', this.wheel, {
            passive: false
          });
          node.addEventListener('touchstart', this.touchStart, {
            passive: false
          });
          node.addEventListener('touchmove', this.touchMove, {
            passive: false
          });
          node.addEventListener('touchend', this.touchEnd, {
            passive: false
          });
        }

        if (this.props.period) {
          this.timer = setTimeout(function () {
            return _this3.cycleNext();
          }, this.props.period);
        }

        this._frame = requestAnimationFrame(function () {
          return _this3.resized(true);
        });
      } else {
        window.removeEventListener('resize', this.resized);
      }
    }
  }, {
    key: "gotPrevButton",
    value: function gotPrevButton(button) {
      var _this4 = this;

      this._prevButton = button;
      if (!this._frame) this._frame = requestAnimationFrame(function () {
        return _this4.resized(true);
      });
    }
  }, {
    key: "gotNextButton",
    value: function gotNextButton(button) {
      var _this5 = this;

      this._nextButton = button;
      if (!this._frame) this._frame = requestAnimationFrame(function () {
        return _this5.resized(true);
      });
    }
  }, {
    key: "resized",
    value: function resized(_value) {
      var _this6 = this;

      this._frame = false;
      if (this.state.disabled) return;
      var w = this.contentNode.parentNode.offsetWidth; // var w = document.body.clientWidth;

      var btn = this.contentNode.parentNode.parentNode.querySelector('.carousel-cycle-prev');
      var bw = btn ? 2 * btn.offsetWidth : 0;
      console.log("Carousel.resized(): container width = ".concat(w, "px, total button width = ").concat(bw)); // w -= bw;

      Object.assign(this.contentNode.style, {
        paddingLeft: 0,
        width: '',
        marginLeft: 0,
        marginRight: 0
      });
      var itemWidth = this.contentNode.querySelector('.carousel-item:first-child').offsetWidth;
      var maxWidth = itemWidth * this.children.length;
      var w1 = Math.floor(w / itemWidth) * itemWidth;
      w1 = Math.min(maxWidth, w1);
      w1 = Math.max(w1, itemWidth);

      if (true || !this.sizeInfinite) {
        w = w1;
      }

      Object.assign(this.contentNode.style, {
        width: '100%',
        paddingLeft: "calc((100% - ".concat(w, "px) / 2)"),
        marginLeft: 0,
        marginRight: 0
      });
      if (this._prevButton) this._prevButton.style.width = "calc((100% - ".concat(w, "px) / 2)");
      if (this._nextButton) this._nextButton.style.width = "calc((100% - ".concat(w, "px) / 2)");
      var prevItemsVisible = this.state.itemsVisible;
      var newItemsVisible = w1 / itemWidth;

      if (_value === true) {
        prevItemsVisible = -1;
      }

      if (newItemsVisible > prevItemsVisible) {
        for (var i = prevItemsVisible + 1; i < newItemsVisible; i++) {
          var p = this.state.leftIndex + i;
          if (p >= this.children.length) p -= this.children.length;
          this.carouselItemEntering(this, this.children[p], p);
        }
      } else if (newItemsVisible < prevItemsVisible) {
        for (var i = prevItemsVisible; i > newItemsVisible; i--) {
          var p = this.state.leftIndex + i;
          if (p >= this.children.length) p -= this.children.length;
          this.carouselItemLeaving(this, this.children[p], p);
        }
      }

      this.setState({
        itemsVisible: w1 / itemWidth
      }, function () {
        if (newItemsVisible > prevItemsVisible) {
          for (var i = prevItemsVisible + 1; i <= newItemsVisible; i++) {
            var p = _this6.state.leftIndex + i;
            if (p >= _this6.children.length) p -= _this6.children.length;

            _this6.carouselItemEntered(_this6, _this6.children[p], p);
          }
        } else if (newItemsVisible < prevItemsVisible) {
          for (var i = prevItemsVisible; i > newItemsVisible; i--) {
            var p = _this6.state.leftIndex + i;
            if (p >= _this6.children.length) p -= _this6.children.length;

            _this6.carouselItemLeft(_this6, _this6.children[p], p);
          }
        }
      });
    }
  }, {
    key: "items",
    value: function items() {
      if (this.mode == 'slide') {
        var end = this.children.slice(this.state.leftIndex); // if (this.infinite) {

        end = end.concat(this.children.slice(0, this.state.leftIndex)); // } else 
        // if (end.length < this.state.itemsVisible && end.length < this.children.length) {
        // 	end = this.children.slice(this.children.length - this.state.itemsVisible);
        // }

        return end;
      }

      return this.children;
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      if (this.state.disabled) {
        return _react.default.createElement("div", {
          className: _classList.default.join('disabled-carousel-container')
        }, _react.default.createElement("div", {
          className: _classList.default.join('carousel-content', this.props.listClassName || "")
        }, this.children.map(function (carouselItem, index) {
          return _react.default.createElement("div", {
            className: "carousel-item",
            key: index,
            ref: function ref(node) {
              return _this7.setupDisabledCarouselItem(node, carouselItem);
            }
          }, _this7.props.items ? null : carouselItem);
        })));
      }

      var isActive = function isActive(node) {
        if (_this7.mode == 'slide') {
          return _this7.items().slice(0, _this7.state.itemsVisible).indexOf(node) != -1;
        }

        return _this7.state.leftIndex == _this7.items().indexOf(node);
      };

      return _react.default.createElement("div", {
        className: _classList.default.join('carousel-container', this.props.noControls ? 'carousel-without-controls' : null, this.props.indicators ? 'carousel-with-indicators' : null)
      }, !this.props.noControls ? _react.default.createElement("div", {
        className: "carousel-cycle-prev",
        ref: this.gotPrevButton
      }, this.state.itemsVisible < this.children.length ? _react.default.createElement("button", {
        disabled: !this.infinite && this.state.leftIndex <= 0,
        onClick: function onClick() {
          return _this7.cyclePrev(true);
        }
      }, _react.default.createElement("span", {
        className: "arrow-circle-icon left",
        "aria-hidden": true
      })) : null) : null, this.props.indicators ? _react.default.createElement("div", {
        className: "carousel-indicator-box"
      }, this.children.map(function (carouselItem, index) {
        return _react.default.createElement("div", {
          key: index,
          style: {
            transition: "".concat(_this7.props.speed || '300', "ms ease")
          },
          "data-index": index,
          onClick: _this7._doCycleToItem,
          className: _classList.default.join('carousel-indicator-item', isActive(carouselItem) ? 'active' : '')
        });
      })) : null, _react.default.createElement("div", {
        className: _classList.default.join('carousel-content', this.infinite ? '' : 'not-infinite', "transition-".concat(this.state.mode), this.props.listClassName, this.state.itemsVisible >= this.children.length ? 'carousel-content-centered' : ''),
        ref: this.setContentNode
      }, this.mode == 'slide' && this.state.itemsVisible < this.children.length ? _react.default.createElement("div", {
        className: _classList.default.join('carousel-item', 'previous-space', !this.state.leftIndex && !this.infinite ? 'placeholder-previous-space' : ''),
        key: "previous",
        ref: function ref(node) {
          return _this7.setupCarouselItem(node, null, "previous");
        }
      }, this.props.items ? null : this.items()[this.items().length - 1]) : null, this.items().map(function (carouselItem, index) {
        return _react.default.createElement("div", {
          className: _classList.default.join('carousel-item', !_this7.infinite && _this7.children.indexOf(carouselItem) < _this7.state.leftIndex ? 'placeholder-next-space' : ''),
          key: index,
          ref: function ref(node) {
            return _this7.setupCarouselItem(node, carouselItem);
          }
        }, _this7.props.items ? null : carouselItem);
      }),
      /* We don't actually need a 'next-space' */
      null), !this.props.noControls ? _react.default.createElement("div", {
        className: "carousel-cycle-next",
        ref: this.gotNextButton
      }, this.state.itemsVisible < this.children.length ? _react.default.createElement("button", {
        disabled: !this.infinite && this.state.leftIndex + this.state.itemsVisible >= this.children.length,
        onClick: function onClick() {
          return _this7.cycleNext(true);
        }
      }, _react.default.createElement("span", {
        className: "arrow-circle-icon right",
        "aria-hidden": true
      })) : null) : null);
    }
  }, {
    key: "setupCarouselItem",
    value: function setupCarouselItem(node, carouselNode, asPreviousItem) {
      if (!carouselNode && asPreviousItem == 'previous') {
        if (this.infinite) {
          var t = this.items();
          carouselNode = t[t.length - 1];
          if (this.props.items) carouselNode = carouselNode.cloneNode(true);
        } else {
          var t = this.children.slice(this.state.leftIndex).concat(this.children.slice(0, this.state.leftIndex));
          carouselNode = t[t.length - 1];
          if (this.props.items) carouselNode = carouselNode.cloneNode(true);
        }
      }

      if (node) {
        if (this.state.mode == 'slide') {
          if (this.props.noTransform) node.style.left = '';else node.style.transform = '';
        } else {
          var t = this.items();
          var pos = t.indexOf(carouselNode);

          if (pos == this.state.leftIndex) {
            node.style.zIndex = 2;
            node.style.opacity = 1;
          } else {
            node.style.zIndex = node.style.opacity = 0;
          }
        }

        if (this.props.items) {
          while (node.firstChild) {
            node.removeChild(node.firstChild);
          }

          node.appendChild(carouselNode);
        }
      }
    }
  }, {
    key: "setupDisabledCarouselItem",
    value: function setupDisabledCarouselItem(node, carouselNode) {
      if (node) {
        if (this.props.noTransform) node.style.left = '';else node.style.transform = '';

        if (this.props.items) {
          while (node.firstChild) {
            node.removeChild(node.firstChild);
          }

          node.appendChild(carouselNode);
        }
      }
    }
  }, {
    key: "cyclePrev",
    value: function cyclePrev() {
      var _this8 = this;

      var userTriggered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.animation) return;
      if (this.state.disabled) return;
      if (!this.infinite && this.state.leftIndex <= 0) return;

      if (_classList.default.has(document.documentElement, 'nav-open') || this.state.itemsVisible >= this.children.length) {
        if (this.props.period) this.timer = setTimeout(function () {
          return _this8.cycleNext();
        }, this.props.period);
        return;
      }

      var positionCallback, finishedCallback;

      finishedCallback = function finishedCallback(finished) {
        if (!finished) positionCallback(1);
        delete _this8.animation;
        var itemLeaving = _this8.state.leftIndex + _this8.state.itemsVisible - 1;
        var itemEntering = _this8.state.leftIndex - 1;
        if (itemLeaving >= _this8.children.length) itemLeaving -= _this8.children.length;
        if (itemEntering < 0) itemEntering += _this8.children.length;

        _this8.carouselItemLeft(_this8, _this8.children[itemLeaving], itemLeaving);

        _this8.carouselItemEntered(_this8, _this8.children[itemEntering], itemEntering);

        _this8.setState(function (state) {
          var lp = state.leftIndex - 1;

          if (_this8.infinite) {
            if (lp == -1) lp = _this8.children.length - 1;
          } else {
            if (lp < 0) lp = 0;
          }

          return {
            leftIndex: lp
          };
        });

        clearTimeout(_this8.timer);
        if (_this8.props.period) _this8.timer = setTimeout(function () {
          return _this8.cycleNext();
        }, _this8.props.period);
      };

      switch (this.mode) {
        case 'slide':
          positionCallback = function positionCallback(position) {
            var pp = -100 + 100 * position;
            console.log(pp);
            var mode = _this8.props.noTransform ? function (node) {
              return node.style.left = "".concat(pp, "%");
            } : function (node) {
              return node.style.transform = "translateX(".concat(pp, "%)");
            };

            _this8.contentNode.querySelectorAll(':scope > .carousel-item').forEach(mode);
          };

          break;

        case 'fade':
          positionCallback = function positionCallback(position) {
            var cq = _this8.contentNode.querySelectorAll(':scope > .carousel-item');

            var c1 = cq[_this8.state.leftIndex - 1] || cq[cq.length - 1]; // target

            var c2 = cq[_this8.state.leftIndex]; // current

            var cr = [].filter.call(cq, function (node) {
              return node != c1 && node != c2;
            });

            if (c1) {
              c1.style.opacity = position;
              c1.style.zIndex = 2;
            }

            if (c2) {
              c2.style.opacity = 1 - position;
              c2.style.zIndex = 1;
            }

            cr.forEach(function (node) {
              node.style.opacity = 0;
              node.style.zIndex = 0;
            });
          };

          break;
      }

      var basePositionCallback = positionCallback;

      positionCallback = function positionCallback(position) {
        if (!_classList.default.has(document.documentElement, 'nav-open')) {
          basePositionCallback(position);
        }
      };

      this.animation = new _animationHelper.default(userTriggered ? 300 : this.props.speed || 300, 'ease', positionCallback, finishedCallback);
      requestAnimationFrame(function () {
        var itemLeaving = _this8.state.leftIndex + _this8.state.itemsVisible - 1;
        var itemEntering = _this8.state.leftIndex - 1;
        if (itemLeaving >= _this8.children.length) itemLeaving -= _this8.children.length;
        if (itemEntering < 0) itemEntering += _this8.children.length;

        _this8.carouselItemLeft(_this8, _this8.children[itemLeaving], itemLeaving);

        _this8.carouselItemEntered(_this8, _this8.children[itemEntering], itemEntering);

        _this8.animation.start();
      });
    }
  }, {
    key: "_doCycleToItem",
    value: function _doCycleToItem(event) {
      this.cycleToItem(Number(event.target.dataset.index));
    }
  }, {
    key: "cycleToItem",
    value: function cycleToItem(index) {
      var _this9 = this;

      if (this.animation) return;
      if (this.state.disabled) return;
      if (_classList.default.has(document.documentElement, 'nav-open') || this.state.itemsVisible >= this.children.length) return; // If an item is clocked on, it always behaves as though cycleNext() happened, only the next item is the item selected.

      if (index == this.state.leftIndex) {
        return; // The current node.
      }

      var positionCallback;
      /*
      switch (this.mode) {
      	case 'slide':
      		positionCallback = position => {
      			var pp = -100 - (100 * position);
      			var mode = this.props.noTransform ? node => node.style.left = `${pp}%` : node => node.style.transform = `translateX(${pp}%)`;
      			this.contentNode.querySelectorAll(':scope > .carousel-item').forEach(mode);
      		};
      		break;
      	case 'fade':
      */

      positionCallback = function positionCallback(position) {
        var cq = _this9.contentNode.querySelectorAll(':scope > .carousel-item');

        var c1, c2;

        if (_this9.mode == 'slide') {
          c2 = cq[1]; // Current item

          if (index < _this9.state.leftIndex) {
            var np = _this9.state.leftIndex - index;
            c1 = cq[cq.length - np];
          } else {
            var np = index - _this9.state.leftIndex;
            c1 = cq[np + 1];
          }
        } else {
          c1 = cq[index];
          c2 = cq[_this9.state.leftIndex]; // current
        }

        var cr = [].filter.call(cq, function (node) {
          return node != c1 && node != c2;
        });

        if (c1) {
          c1.style.opacity = position;
          c1.style.zIndex = 2;
        }

        if (c2) {
          c2.style.opacity = 1 - position;
          c2.style.zIndex = 1;
        }

        cr.forEach(function (node) {
          node.style.zIndex = node.style.opacity = 0;
        });
      };
      /*
      		break;
      }
      */


      var basePositionCallback = positionCallback;

      positionCallback = function positionCallback(position) {
        if (!_classList.default.has(document.documentElement, 'nav-open')) {
          basePositionCallback(position);
        }
      };

      var finishedCallback = function finishedCallback(finished) {
        if (!finished) positionCallback(1);
        delete _this9.animation; // This only really works for a single-item carousel.

        var itemEntering = index;
        var itemLeaving = _this9.state.leftIndex;

        _this9.carouselItemLeft(_this9, _this9.children[_this9.state.leftIndex], _this9.state.leftIndex);

        _this9.carouselItemEntered(_this9, _this9.children[itemEntering], itemEntering);

        _this9.setState(function (state) {
          var lp = index;

          if (lp - 1 + state.itemsVisible >= _this9.children.length) {
            lp = _this9.children.length - state.itemsVisible;
          }

          return {
            leftIndex: lp,
            mode: _this9.mode
          };
        }, function () {
          if (_this9.mode == 'slide') {
            var cq = _this9.contentNode.querySelectorAll(':scope > .carousel-item');

            cq.forEach(function (node) {
              node.style.zIndex = node.style.opacity = '';
            });
          }
        });

        clearTimeout(_this9.timer);
        if (_this9.props.period) _this9.timer = setTimeout(function () {
          return _this9.cycleNext();
        }, _this9.props.period);
      };

      if (this.props.period) clearTimeout(this.timer);
      this.animation = new _animationHelper.default(300, 'ease', positionCallback, finishedCallback);
      this.setState({
        mode: 'fade'
      }, function () {
        var itemEntering = index;
        var itemLeaving = _this9.state.leftIndex;

        _this9.carouselItemLeaving(_this9, _this9.children[_this9.state.leftIndex], _this9.state.leftIndex);

        _this9.carouselItemEntering(_this9, _this9.children[itemEntering], itemEntering);

        requestAnimationFrame(function () {
          _this9.animation.start();
        });
      });
    }
  }, {
    key: "cycleNext",
    value: function cycleNext() {
      var _this10 = this;

      var userTriggered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.animation) return;
      if (this.state.disabled) return;
      if (!this.infinite && this.state.leftIndex + this.state.itemsVisible >= this.children.length) return;

      if (_classList.default.has(document.documentElement, 'nav-open') || this.state.itemsVisible >= this.children.length) {
        if (this.props.period) this.timer = setTimeout(function () {
          return _this10.cycleNext();
        }, this.props.period);
        return;
      }

      var pl = [],
          pv = -100;
      var positionCallback;

      switch (this.mode) {
        case 'slide':
          positionCallback = function positionCallback(position) {
            var pp = -100 - 100 * position;
            pl.push(pv - pp);
            pv = pp; // console.log(pp);

            var mode = _this10.props.noTransform ? function (node) {
              return node.style.left = "".concat(pp, "%");
            } : function (node) {
              return node.style.transform = "translateX(".concat(pp, "%)");
            };

            _this10.contentNode.querySelectorAll(':scope > .carousel-item').forEach(mode);
          };

          break;

        case 'fade':
          positionCallback = function positionCallback(position) {
            var cq = _this10.contentNode.querySelectorAll(':scope > .carousel-item');

            var c1 = cq[_this10.state.leftIndex + 1] || cq[0]; // target

            var c2 = cq[_this10.state.leftIndex]; // current

            var cr = [].filter.call(cq, function (node) {
              return node != c1 && node != c2;
            });

            if (c1) {
              c1.style.opacity = position;
              c1.style.zIndex = 2;
            }

            if (c2) {
              c2.style.opacity = 1 - position;
              c2.style.zIndex = 1;
            }

            cr.forEach(function (node) {
              node.style.zIndex = node.style.opacity = 0;
            });
          };

          break;
      }

      var basePositionCallback = positionCallback;

      positionCallback = function positionCallback(position) {
        if (!_classList.default.has(document.documentElement, 'nav-open')) {
          basePositionCallback(position);
        }
      };

      var finishedCallback = function finishedCallback(finished) {
        if (!finished) positionCallback(1);
        delete _this10.animation;
        console.log(pl);
        var itemEntering = _this10.state.leftIndex + _this10.state.itemsVisible;
        if (_this10.children.length <= itemEntering) itemEntering -= _this10.children.length;

        _this10.carouselItemLeft(_this10, _this10.children[_this10.state.leftIndex], _this10.state.leftIndex);

        _this10.carouselItemEntered(_this10, _this10.children[itemEntering], itemEntering);

        _this10.setState(function (state) {
          var lp = state.leftIndex + 1;

          if (_this10.infinite) {
            if (lp == _this10.children.length) lp = 0;
          } else {
            if (state.leftIndex + state.itemsVisible >= _this10.children.length) {
              lp = _this10.children.length - state.itemsVisible;
            }
          }

          return {
            leftIndex: lp
          };
        });

        clearTimeout(_this10.timer);
        if (_this10.props.period) _this10.timer = setTimeout(function () {
          return _this10.cycleNext();
        }, _this10.props.period);
      };

      this.animation = new _animationHelper.default(userTriggered ? 300 : this.props.speed || 300, 'ease', positionCallback, finishedCallback);
      requestAnimationFrame(function () {
        var itemEntering = _this10.state.leftIndex + _this10.state.itemsVisible;
        if (_this10.children.length <= itemEntering) itemEntering -= _this10.children.length;

        _this10.carouselItemLeaving(_this10, _this10.children[_this10.state.leftIndex], _this10.state.leftIndex);

        _this10.carouselItemEntering(_this10, _this10.children[itemEntering], itemEntering);

        _this10.animation.start();
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.items && prevState.isMobile != this.state.isMobile) {
        var itemPosition = this.props.items.map(function (v, i) {
          return v.dataset.mobileCarouselStartHere == 'true' ? i : null;
        }).filter(function (v) {
          return v !== null;
        }).shift();

        if (itemPosition !== void 0) {
          this.setState({
            leftIndex: this.state.isMobile ? itemPosition : 0
          });
        }
      }
    }
  }, {
    key: "children",
    get: function get() {
      if (this.props.items) return this.props.items;
      if (this._lastChildren === this.props.children) return this._lastChildrenArray;
      this._lastChildrenArray = _react.default.Children.toArray(this.props.children);
      this._lastChildren = this.props.children;
      return this._lastChildrenArray;
    }
  }], [{
    key: "setup",
    value: function setup(parent, props) {
      var carouselItems = [].slice.call(parent.childNodes).filter(function (node) {
        return node.nodeType == 1;
      });
      var xc = [];
      if (_classList.default.has(parent, 'block')) xc.push('block');
      if (_classList.default.has(parent, 'stack')) xc.push('stack');
      var classNames = parent.className;

      while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
      }

      parent.className = xc.join(' ');
      props = Object.assign({}, props || {});

      _reactDom.default.render(_react.default.createElement(Carousel, _extends({
        items: carouselItems,
        listClassName: classNames
      }, props)), parent);

      var ret = {
        remove: function remove() {
          _reactDom.default.unmountComponentAtNode(parent);

          for (var i = 0; i < carouselItems.length; i++) {
            parent.appendChild(carouselItems[i]);
          }

          Carousel.carousels = Carousel.carousels.filter(function (node) {
            if (node == ret) return false;
            if (document.documentElement.contains(node._parent)) return true;

            _reactDom.default.unmountComponentAtNode(node._parent);

            return false;
          });
        },
        _parent: parent
      };
      this.carousels.push(ret);
      this.carousels = this.carousels.filter(function (node) {
        if (document.documentElement.contains(node._parent)) return true;

        _reactDom.default.unmountComponentAtNode(node._parent);

        return false;
      });
      return ret;
    }
  }]);
  return Carousel;
}(_react.Component), _class2.carousels = [], _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "infinite", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "mode", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "slide";
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "sizeInfinite", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.infinite;
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "carouselItemLeaving", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (carousel, child, index) {};
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "carouselItemLeft", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (carousel, child, index) {};
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "carouselItemEntering", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (carousel, child, index) {};
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "carouselItemEntered", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (carousel, child, index) {};
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "wheelTimeoutHandler", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "wheelTimeoutHandler"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "wheel", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "wheel"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "touchStart", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "touchStart"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "touchMove", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "touchMove"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "touchEnd", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "touchEnd"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "mobileMediaQueryListener", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "mobileMediaQueryListener"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "mediaQueryListener", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "mediaQueryListener"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setContentNode", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setContentNode"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotPrevButton", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotPrevButton"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotNextButton", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotNextButton"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "resized", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "resized"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_doCycleToItem", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_doCycleToItem"), _class.prototype)), _class);
exports.default = Carousel;